<!doctype html>
<html class="standalone webshop apps">
</html>

<router-outlet></router-outlet>
<ngx-spinner></ngx-spinner>